// @ts-nocheck
export const VERSION_ID = ENV_VERSION_ID;

export const BASE_URL = ENV_BASE_URL;
export const BACKOFFICE_URL = ENV_BACKOFFICE_URL;
export const CHECKOUT_JS_URL = ENV_CHECKOUT_JS_URL;
export const GATEWAY_URL = ENV_GATEWAY_URL;
export const TRACKER_URL = ENV_TRACKER_URL;
export const ORIGIN_NAME = ENV_ORIGIN_NAME;

export const SHIFT4_BASE_URL = ENV_SHIFT4_BASE_URL;
export const SHIFT4_BACKOFFICE_URL = ENV_SHIFT4_BACKOFFICE_URL;
export const SHIFT4_CHECKOUT_JS_URL = ENV_SHIFT4_CHECKOUT_JS_URL;
export const SHIFT4_GATEWAY_URL = ENV_SHIFT4_GATEWAY_URL;

export const DEBUG_POST_MESSAGE = ENV_DEBUG_POST_MESSAGE;
export const COMPANY_NAME = ENV_COMPANY_NAME;
export const COMPANY_NAME_LOWER_CASE = ENV_COMPANY_NAME_LOWER_CASE;
